import React, { useCallback } from 'react';
import { useIntl } from 'react-intl';
import { cx } from '@emotion/css';
import { ProfileLinkProps } from './profile-link.models';
import { useStyles } from './profile-link.styles';
import { DeactivationBanner } from './deactivation-banner';
import { InternalLinks } from '../../../../../constants';

export const ProfileLink = ({
  image,
  url,
  text,
  date,
  letter,
  name,
  color,
  isDeactivatedSoon,
  dateOfDeactivation,
  active,
  testId,
}: ProfileLinkProps): JSX.Element => {
  const classes = useStyles();
  const intl = useIntl();
  const ariaLabel = useCallback((id: string) => {
    return intl.formatMessage({ id }, { noBreak: <>&nbsp;</> }) as unknown as string;
  }, []);

  const avatarColor = !active ? '#b5b5b7' : color || 'transparent';
  // Don't remove data-testid: it is used by Yandex Metrica.
  const linkTestId = testId ?? (
    url === InternalLinks.aboutProfile
      ? 'about-kids-profile-link'
      : url === InternalLinks.ecpLocator
        ? 'get-contact-lenses-link'
        : ''
  );


  return (
    <div
      className={cx(classes.root, {
        [classes.rootGrey]: !active && !text,
      })}
    >
      <div className={classes.profileContent}>
        {image && <img width={44} height={44} className={classes.img} src={image} alt="" />}
        {letter && (
          <div
            aria-hidden="true"
            className={cx(classes.letter, { [classes.letterDisabled]: !active })}
            style={{ background: avatarColor }}
          >
            {letter}
          </div>
        )}
        <div className={cx(classes.text, { [classes.textLetter]: !!letter })}>
          {text && intl.formatMessage({ id: text }, { noBreak: <>&nbsp;</> })}
          {name && name}
          {date && (
            <span className={classes.date}>
              {new Date(date).toLocaleDateString(intl.locale, {
                day: 'numeric',
                month: 'numeric',
                year: 'numeric',
              })}
            </span>
          )}
        </div>
        {text && (
          <a className={classes.link} href={url} aria-label={ariaLabel(text)} data-testid={linkTestId}></a> // Don't remove data-testid: it is used by Yandex Metrica.
        )}
        {text && <div className={cx(classes.link, classes.linkDisabled)}></div>}
        {name && url && active && (
          <a href={url} className={classes.link} aria-label={name} data-testid={linkTestId}></a> // Don't remove data-testid: it is used by Yandex Metrica.
        )}
        {name && !active && <div className={cx(classes.link, classes.linkDisabled)}></div>}
      </div>

      {((name && !active) || isDeactivatedSoon) && (
        <DeactivationBanner active={active} dateOfDeactivation={dateOfDeactivation} />
      )}
    </div>
  );
};
